/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quote: NonNullable<unknown> }} Admin_Billing_Currency_Toggle_Quote_LabelInputs */

const es_admin_billing_currency_toggle_quote_label = /** @type {(inputs: Admin_Billing_Currency_Toggle_Quote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 USD = ARS ${i?.quote}`)
};

const en_admin_billing_currency_toggle_quote_label = /** @type {(inputs: Admin_Billing_Currency_Toggle_Quote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 USD = ARS ${i?.quote}`)
};

/**
* | output |
* | --- |
* | "1 USD = ARS {quote}" |
*
* @param {Admin_Billing_Currency_Toggle_Quote_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_currency_toggle_quote_label = /** @type {((inputs: Admin_Billing_Currency_Toggle_Quote_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Currency_Toggle_Quote_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_currency_toggle_quote_label(inputs)
	return en_admin_billing_currency_toggle_quote_label(inputs)
});
export { admin_billing_currency_toggle_quote_label as "admin.billing.currency_toggle.quote_label" }